import React from "react";
import { Outlet } from "react-router-dom";
import Bars from "../../components/bars/Bars";

import Sidebar from "../components/dash-sidebar/Sidebar";
import Search from "../components/search/Search";
import "./dashLayout.scss";

const DashLayout = () => {
  return (
    <div className="main-container">
      <Sidebar />
      <Bars />
      <div className="section">
        <div className="container">
          <Search />
          <Outlet />
        </div>
      </div>
    </div>
  );
};

export default DashLayout;
